export default [
  { value: 'CHANGE_MIND', name: 'CLAIM_COMMON_CHANGE_MIND' },
  { value: 'DEFECTIVE_PRODUCT', name: 'CLAIM_COMMON_DEFECTIVE_PRODUCT' },
  { value: 'WRONG_DELIVERY', name: 'CLAIM_COMMON_WRONG_DELIVERY' },
  { value: 'WRONG_PRODUCT_DETAIL', name: 'CLAIM_COMMON_WRONG_PRODUCT_DETAIL' },
  { value: 'DELAY_DELIVERY', name: 'CLAIM_COMMON_DELAY_DELIVERY' },
  { value: 'OUT_OF_STOCK', name: 'CLAIM_COMMON_OUT_OF_STOCK' },
  { value: 'OTHERS_SELLER', name: 'CLAIM_COMMON_OTHERS_SELLER' },
  { value: 'OTHERS_BUYER', name: 'CLAIM_COMMON_OTHERS_BUYER' },
];